import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { map } from 'rxjs/operators';
import { PushNotificationsService } from 'src/app/services/push-notifications.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { User } from 'src/app/interfaces/user.interface';
import { ApiV2Service } from 'src/app/services/api-v2.service';
import { Activity } from '../../../models/activity.model';
import { Organization } from 'src/app/interfaces/organization-info.interface';
import { AuthService } from 'src/app/services/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dialog-push-message',
  templateUrl: './dialog-push-message.component.html',
  styleUrls: ['./dialog-push-message.component.css']
})
export class DialogPushMessageComponent implements OnInit {

  pushMessageForm: FormGroup;
  pushMessageinput:string;
  messageDefault: string;
  choice: string=this.translate.instant('COURSES.PUSHMSGDEFAULT');
  choices: string[] = [this.translate.instant('COURSES.PUSHMSGDEFAULT'), this.translate.instant('COURSES.PUSHMSGWRITE')];
  

  icons: any = {
    success: { icon: 'check_circle' },
    info: { icon: 'info' },
    danger: { icon: 'error' },
    warning: { icon: 'warning' },
    question: { icon: 'help' }
  }


  constructor(
    private translate:TranslateService,
    private api: ApiV2Service,
    private auth: AuthService,
    private notification: PushNotificationsService,
    private dialogRef: MatDialogRef<DialogPushMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pushMessageForm = new FormGroup({
      pushMessage: new FormControl(null)
    });
  }

ngOnInit(): void{
  console.log (this.choice)
}

  public closeMe() {
    this.dialogRef.close();
  }


}
